const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon ionic-ios-mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.44,
    height: 12.074,
    viewBox: "0 0 17.44 12.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13237",
    d: "m20.673 10.34-4.511 4.595a.081.081 0 0 0 0 .117l3.157 3.362a.544.544 0 0 1 0 .771.547.547 0 0 1-.771 0L15.4 15.836a.086.086 0 0 0-.122 0l-.767.78a3.375 3.375 0 0 1-2.406 1.015 3.443 3.443 0 0 1-2.457-1.044l-.738-.75a.086.086 0 0 0-.122 0l-3.144 3.35a.547.547 0 0 1-.771 0 .544.544 0 0 1 0-.771l3.157-3.362a.089.089 0 0 0 0-.117L3.518 10.34a.083.083 0 0 0-.143.059v9.194a1.346 1.346 0 0 0 1.342 1.342h14.757a1.346 1.346 0 0 0 1.342-1.342V10.4a.084.084 0 0 0-.143-.06z",
    transform: "translate(-3.375 -8.86)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13238",
    d: "M12.439 15.551a2.279 2.279 0 0 0 1.639-.688l6.578-6.7a1.318 1.318 0 0 0-.83-.293H5.056a1.309 1.309 0 0 0-.83.293l6.578 6.7a2.28 2.28 0 0 0 1.635.688z",
    transform: "translate(-3.719 -7.875)",
    style: {
      fill: "#313280"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8bf262e9c259e870f74685f511a2f29d.svg";
export { ForwardRef as ReactComponent };